
import ReferenceSection from './ReferenceSection';

const ReferenceContainer = ({
  references = [],
  register,
  control,
  errors,
}) => {
  return references
    .filter(({ reference }) => Boolean(reference))
    .map(({ reference, position }, index) => (
      <ReferenceSection
        key={`reference-${position}`}
        referenceData={reference}
        position={position}
        index={index}
        register={register}
        control={control}
        errors={errors}
      />
    ));
};

export default ReferenceContainer;
